export type AppConfig = {
  flags: {
    comingSoonEnabled: boolean;
    livePoll: boolean;
    chatLiveModel: boolean;
    applicationsOpen: boolean;
    topicsOpen: boolean;
  };
  // Server-side answer: is the caller past the gate? True if the launch flag
  // is off, or if the request carried a valid preview cookie. The browser
  // can't compute this itself because the cookie is HttpOnly.
  unlocked: boolean;
};

export async function fetchConfig(timeoutMs = 5000): Promise<AppConfig> {
  const res = await fetch('/api/config', {
    credentials: 'include',
    signal: AbortSignal.timeout(timeoutMs),
  });
  if (!res.ok) throw new Error(`config request failed: ${res.status}`);
  return (await res.json()) as AppConfig;
}

export async function grantPreview(token: string): Promise<boolean> {
  const res = await fetch('/api/preview/grant', {
    method: 'POST',
    credentials: 'include',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ token }),
  });
  return res.status === 204;
}
